import React from 'react'
import { MsalAuthenticationTemplate } from '@azure/msal-react'
import { InteractionType } from '@azure/msal-browser'

const Login = () => {
  // const { instance } = useMsal();

  function ErrorComponent({ error }) {
    return <p>An Error Occurred: {error}</p>
  }

  function LoadingComponent() {
    return <div>Redireccionando al Login...</div>
  }

  const handleRedirect = () => {
    const redirectPath = window.location
    sessionStorage.setItem('redirectPath', redirectPath) // Guarda la URL actual
  }
  // instance.loginRedirect(loginRequest);
  return (
    // authenticationRequest, errorComponent and loadingComponent props are optional
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      errorComponent={ErrorComponent}
      loadingComponent={LoadingComponent}
      onRedirectStart={handleRedirect}
    >
      <p>At least one account is signed in!</p>
    </MsalAuthenticationTemplate>
  )

  // return (
  //     <div>
  //         <h1>Login</h1>
  //         <button type='button' onClick={() => instance.loginRedirect(loginRequest)}>Login</button>
  //     </div>
  // )
}

export default Login
